import { t } from 'i18next'
import type { FC } from 'react'
import { useMatch } from 'react-router-dom'
import { HoverTooltip } from '#components/HoverTooltip'
import { Icon } from '#components/Icon'
import { HeaderHomeContainer as HeaderHome, NavLinkTabHeader } from '#features/AppLayout'
import HomeIcon from '#icons/home-48.svg'

export const HomeHeader: FC = () => {
  const isSetupPage = useMatch('/setup')

  return (
    <HeaderHome>
      <HoverTooltip.span title={t('shared:common.button.home')}>
        <NavLinkTabHeader to="/setup" active={!!isSetupPage}>
          <Icon iconUrl={HomeIcon} />
        </NavLinkTabHeader>
      </HoverTooltip.span>
    </HeaderHome>
  )
}
